<a class="btn btn-link small p-0 m-0" (click)="goOnObjectDetail()">
    <em class="fas fa-link text-primary mr-3 fa-xs"></em>
    <span class="small">{{ objectName }}</span>
</a>
